/** The scaffold's base datum — how far the jacks are wound out on level ground. */

import { BASE_DATUM_MAX_MM, BASE_DATUM_MIN_MM } from "../../data/haki.ts";
import { getEngine } from "../engine/engine.actions.ts";
import { setHud } from "../hud/hud.actions.ts";
import { datumState } from "./datum.state.ts";

export { BASE_DATUM_MAX_MM, BASE_DATUM_MIN_MM };

/** Step of the ribbon control, millimetres. */
export const BASE_DATUM_STEP_MM = 5;

/** Apply a datum and re-render. The engine clamps, so the store gets the real value. */
export function setBaseDatum(mm: number, announce = true): void {
  const applied = getEngine().setBaseDatum(mm);

  datumState.set({ baseDatumMm: applied });
  if (announce) {
    setHud(`Base jack ${applied} mm on level ground — the whole grid moves with it`);
  }
}
